import React from 'react';
import PolicyReport from '../LifePolicyRegister/PolicyReport';

export default function MaturityPoliciesReportPreview() {
  // Ensure PolicyReport reads filters from location.state.payload
  // Show Policy Status and include a maturity sort option only for this report
  return <PolicyReport includeMaturityDate={true} includePolicyStatus={true} headerTitle={"Maturity Policies Report"} extraSortOptions={[{ key: 'maturity', label: 'Maturity Date' }]} initialSort={'maturity'} />;
}
